// extracted by mini-css-extract-plugin
export var formContainer = "_i7-0";
export var message = "_i7-1";